import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetScrnSchBlockedListsRequest extends BaseServiceRequest {
    constructor() {
        super();
        super.addRequestUri("scrnschblklists.pb");
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.LIST;
    }

    getMessageName() {
        return "scrnSchBlockedListsResponse";
    }
}

export default GetScrnSchBlockedListsRequest;